/**
 * Хранение локального access-токена участника (B-1973, SSO).
 *
 * Личность выдаёт `id.drafter.ru` — токен Драфтера живёт в общей httpOnly-cookie
 * `.drafter.ru`, недоступной JS. Здесь храним только **локальный drafter-access**
 * Акселератора (TTL 15 мин) + id лида. Истёк access → `lib/api` молча повторяет
 * обмен (браузер сам приложит cookie). Своего токена Драфтера на клиенте нет.
 */

const ACCESS_KEY = 'drafter_cabinet_access';
const LEAD_KEY = 'drafter_cabinet_lead_id';

export interface StoredSession {
  accessToken: string;
  leadId: string | null;
}

export const tokenStorage = {
  save(session: StoredSession): void {
    localStorage.setItem(ACCESS_KEY, session.accessToken);
    if (session.leadId) localStorage.setItem(LEAD_KEY, session.leadId);
    else localStorage.removeItem(LEAD_KEY);
  },

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },

  saveAccessToken(token: string): void {
    localStorage.setItem(ACCESS_KEY, token);
  },

  getLeadId(): string | null {
    return localStorage.getItem(LEAD_KEY);
  },

  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(LEAD_KEY);
  },
};

/** Полная очистка клиентского состояния при выходе из кабинета.
 *
 * 1. localStorage: токены + любые legacy-флаги (drafter:*).
 * 2. sessionStorage: всё.
 * 3. Cookies на нашем домене — все, кроме httpOnly (общую cookie `.drafter.ru`
 *    стирает только IdP; она httpOnly и JS недоступна).
 */
export function clearAllClientState(): void {
  try {
    tokenStorage.clear();
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('drafter')) keysToRemove.push(key);
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    /* приватный режим браузера может бросать SecurityError */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* same */
  }
  try {
    const cookies = document.cookie.split(';');
    for (const c of cookies) {
      const eq = c.indexOf('=');
      const name = (eq > -1 ? c.substring(0, eq) : c).trim();
      if (!name) continue;
      const expired = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
      document.cookie = expired;
      document.cookie = `${expired}; domain=${window.location.hostname}`;
      document.cookie = `${expired}; domain=.${window.location.hostname.replace(/^[^.]+\./, '')}`;
    }
  } catch {
    /* document.cookie может быть недоступен в очень странных контекстах */
  }
}
